import { render, staticRenderFns } from "./ServiceInvoiceItem.vue?vue&type=template&id=6df527ff&scoped=true&"
import script from "./ServiceInvoiceItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceInvoiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceInvoiceItem.vue?vue&type=style&index=0&id=6df527ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df527ff",
  null
  
)

export default component.exports